const CNPJ_FORMAT = /^[A-Z0-9]{12}\d{2}$/;

// CNPJ pode ser alfanumerico (A-Z e 0-9) nas 12 primeiras posicoes; os 2 digitos verificadores seguem numericos.
export const stripCnpj = (value?: string | null): string =>
  (value ?? '').replace(/[^A-Za-z0-9]/g, '').toUpperCase();

const cnpjCheckDigit = (base: string): number => {
  let weight = 2;
  let sum = 0;

  for (let i = base.length - 1; i >= 0; i--) {
    sum += (base.charCodeAt(i) - 48) * weight;
    weight = weight === 9 ? 2 : weight + 1;
  }

  const remainder = sum % 11;

  return remainder < 2 ? 0 : 11 - remainder;
};

// Valor de cada caractere = codigo ASCII - 48; para CNPJ so numerico e o proprio digito, entao o calculo legado continua valendo.
export const isValidCnpj = (value?: string | null): boolean => {
  const cnpj = stripCnpj(value);

  if (!CNPJ_FORMAT.test(cnpj) || /^(.)\1+$/.test(cnpj)) {
    return false;
  }

  const base = cnpj.slice(0, 12);
  const dv1 = cnpjCheckDigit(base);
  const dv2 = cnpjCheckDigit(`${base}${dv1}`);

  return cnpj.slice(12) === `${dv1}${dv2}`;
};

export const formatCnpj = (value?: string | null): string =>
  stripCnpj(value)
    .slice(0, 14)
    .replace(/^([A-Z0-9]{2})([A-Z0-9])/, '$1.$2')
    .replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})([A-Z0-9])/, '$1.$2.$3')
    .replace(/\.([A-Z0-9]{3})([A-Z0-9])/, '.$1/$2')
    .replace(/([A-Z0-9]{4})(\d)/, '$1-$2');

export const formatCpf = (value?: string | null): string =>
  (value ?? '')
    .replace(/\D/g, '')
    .slice(0, 11)
    .replace(/^(\d{3})(\d)/, '$1.$2')
    .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1-$2');

// Ate 11 digitos e CPF; com letra ou mais de 11 caracteres e CNPJ.
export const isCnpjInput = (value?: string | null): boolean =>
  !/^\d{0,11}$/.test(stripCnpj(value));

export const formatCpfOrCnpj = (value?: string | null): string =>
  isCnpjInput(value) ? formatCnpj(value) : formatCpf(value);
